// ============================================================
// EDIT THIS FILE to personalise the site.
// Everything marked [REPLACE ...] is a clearly marked placeholder.
// ============================================================

export const BRAND = {
  name: "Mahesh Panchal",
  company: "EXIM INDIA",
  logo: "/assets/exim-india-logo.png",
  tagline: "40 Years of Global Trade Expertise. Now Powered by AI.",
  positioning:
    "A veteran Export-Import expert turned AI & Digital strategist, helping businesses trade globally and grow digitally.",
  email: "eximindia2025@gmail.com",
  phone: "+91 98258 66425",
  whatsapp: "+91 98258 66425",
  address: "210, Satva Icon, Vastral Cross Road, S.P. Ring Road, Vastral, Ahmedabad-382418, Gujarat, INDIA",
  bookingLink: "#", // [REPLACE WITH YOUR CALENDLY / BOOKING LINK]
  linkedin: "http://www.linkedin.com/in/mahesh-panchal-19026b42",
  instagram: "https://www.instagram.com/eximindia2025/",
  facebook: "https://www.facebook.com/profile.php?id=61587433942520",
};

export const GMAIL_COMPOSE = `https://mail.google.com/mail/?view=cm&fs=1&to=${BRAND.email}&su=${encodeURIComponent(
  "Business Enquiry — EXIM INDIA Website"
)}&body=${encodeURIComponent(
  "Hello Mahesh,\n\n[Write your message here]\n\nMy name: \nMy email: \nMy phone: "
)}`;

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1590497008432-598f04441de8?q=80&w=2000&auto=format&fit=crop",
  portrait: "/assets/mahesh-panchal.jpg",
  ai: "https://images.pexels.com/photos/8640331/pexels-photo-8640331.jpeg?auto=compress&cs=tinysrgb&w=1600",
  consulting: "/assets/mahesh-seminar.png",
  video: "/assets/exim-ad-web.mp4",
  videoWebm: "/assets/exim-ad.webm",
};

export const MARQUEE_ITEMS = [
  "Global Trade",
  "Export-Import",
  "AI Strategy",
  "MSME Coaching",
  "Web & App Development",
  "Digital Transformation",
  "Trade Documentation",
  "Mentorship",
];

// [REPLACE WITH YOUR REAL NUMBERS]
export const STATS = [
  { value: 40, suffix: "+", label: "Years of Experience" },
  { value: 25, suffix: "+", label: "Countries Traded" },
  { value: 500, suffix: "+", label: "MSMEs Trained" },
  { value: 1000, suffix: "+", label: "Shipments Facilitated" },
];

export const PILLARS = [
  {
    slug: "export-import-business",
    number: "01",
    title: "Export-Import Business",
    desc: "Direct trading operations across global markets — sourcing, negotiation, logistics, documentation and delivery, handled end-to-end.",
    cta: "Learn More",
    to: "/export-import-business",
    accent: "gold",
    icon: "Ship",
  },
  {
    slug: "consulting-training",
    number: "02",
    title: "Consulting, Training & Coaching",
    desc: "1-on-1 consulting, group workshops and ongoing coaching that take MSMEs and startups from first enquiry to first shipment.",
    cta: "Learn More",
    to: "/consulting-training",
    accent: "gold",
    icon: "GraduationCap",
  },
  {
    slug: "ai-digital-services",
    number: "03",
    title: "AI Strategy & Web/App Development",
    desc: "AI strategy consulting, websites, web apps and digital platforms that modernise how traditional businesses sell and operate.",
    cta: "Learn More",
    to: "/ai-digital-services",
    accent: "teal",
    icon: "Cpu",
  },
];

export const WHY_POINTS = [
  {
    title: "Four Decades at the Frontline",
    desc: "Real shipments, real customs houses, real negotiations across dozens of markets. The guidance you get is earned, not read from a textbook.",
  },
  {
    title: "Old-World Wisdom, New-World Tools",
    desc: "A rare combination: deep traditional trade expertise paired with hands-on AI strategy and modern web development. One partner for both worlds.",
  },
  {
    title: "Proven, Not Theoretical",
    desc: "Hundreds of MSMEs trained, countless deals closed, and businesses taken from local to global — with documented, repeatable processes.",
  },
  {
    title: "A Mentor, Not a Vendor",
    desc: "You work directly with me — no juniors, no hand-offs. Honest advice, personal attention, and a genuine stake in your success.",
  },
];

// SAMPLE TESTIMONIALS — [REPLACE WITH REAL CLIENT QUOTES, NAMES & COMPANIES]
export const TESTIMONIALS = [
  {
    quote:
      "We went from zero export experience to our first international order in under three months. The step-by-step coaching made all the difference.",
    name: "[Client Name]",
    role: "[Founder, MSME Manufacturing Co.]",
  },
  {
    quote:
      "Forty years of experience shows in every conversation. Documentation, compliance, pricing — everything was demystified for our team.",
    name: "[Client Name]",
    role: "[Director, Agro-Exports Startup]",
  },
  {
    quote:
      "He understood our traditional trade business first, then showed us exactly where AI and a modern website would pay for themselves. Rare and valuable.",
    name: "[Client Name]",
    role: "[MD, Family Trading House]",
  },
  {
    quote:
      "The workshop gave our entire sales team a working knowledge of Incoterms, LC documentation and buyer negotiation. Worth every rupee.",
    name: "[Client Name]",
    role: "[CEO, Handicrafts Export Firm]",
  },
  {
    quote:
      "Our new digital platform cut enquiry response time from days to minutes. A trade veteran who builds software is an unfair advantage.",
    name: "[Client Name]",
    role: "[Founder, B2B Trading Startup]",
  },
  {
    quote:
      "Patient, precise and always available. The ongoing coaching kept us compliant and confident through our first year of exports.",
    name: "[Client Name]",
    role: "[Partner, Textile Export House]",
  },
];

// SAMPLE CASE STUDIES — [REPLACE WITH YOUR REAL CASE STUDIES]
export const CASE_STUDIES = [
  {
    title: "First Export in 90 Days",
    challenge: "A textile MSME had quality products but no idea how to find buyers, price for export, or handle documentation.",
    solution: "A structured coaching plan: market selection, buyer outreach scripts, pricing worksheets and document checklists.",
    result: "First confirmed export order within 90 days, with a repeatable process for the next five markets.",
  },
  {
    title: "From Compliance Chaos to Confidence",
    challenge: "A growing startup faced repeated shipment delays due to documentation errors and unclear Incoterms.",
    solution: "A compliance audit, team training workshop, and a custom documentation SOP for every shipment type.",
    result: "Zero documentation-related delays in the following year and faster customs clearance across ports.",
  },
  {
    title: "A 40-Year-Old Firm Goes Digital",
    challenge: "A traditional trading house relied entirely on phone calls and paper records, losing younger buyers to digital-first competitors.",
    solution: "AI-assisted enquiry handling, a modern website, and a simple digital catalogue with automated follow-ups.",
    result: "Enquiry response time cut from days to minutes, and a measurable lift in new-buyer conversions.",
  },
];

// [REPLACE WITH YOUR REAL MILESTONES]
export const MILESTONES = [
  {
    year: "1986",
    title: "The First Shipment",
    desc: "Started in the export-import trade — learning sourcing, shipping and customs the hands-on way, one consignment at a time.",
  },
  {
    year: "1995",
    title: "Building a Global Network",
    desc: "Expanded trading relationships across [X]+ countries, from buyer negotiations to long-term supply partnerships.",
  },
  {
    year: "2010",
    title: "Teaching the Next Generation",
    desc: "Began formally training and coaching MSMEs and startups entering global trade — turning experience into curriculum.",
  },
  {
    year: "2020",
    title: "The Digital Awakening",
    desc: "Watched businesses struggle to modernise — and started building websites, web apps and digital platforms to help them.",
  },
  {
    year: "2026",
    title: "The AI Chapter",
    desc: "Brought AI strategy into the practice — helping traditional trade businesses adopt intelligent tools without losing their soul.",
  },
];

export const SERVICE_OPTIONS = [
  { value: "export-import-business", label: "Export-Import Business" },
  { value: "consulting-training", label: "Consulting / Training / Coaching" },
  { value: "ai-digital-services", label: "AI & Digital Services" },
  { value: "other", label: "Something Else" },
];

// SAMPLE ARTICLES — [REPLACE WITH YOUR OWN WRITING]
export const BLOG_POSTS = [
  {
    slug: "first-shipment-is-the-hardest",
    title: "The First Shipment Is the Hardest — Here's How to Make It Happen",
    excerpt:
      "Every exporter remembers their first shipment. The fear, the paperwork, the waiting. Here's the exact sequence I walk my coaching clients through.",
    category: "Export-Import",
    date: "June 2026",
    readTime: "6 min read",
    content: [
      "After forty years in this business, I can tell you the truth nobody puts in the textbooks: the first shipment is 80% psychology and 20% logistics. The paperwork is learnable. The fear is what stops most businesses.",
      "Start smaller than your ego wants. A sample order to a nearby market teaches you the entire cycle — proforma invoice, packing list, shipping bill, bill of lading — without risking your working capital. You are buying an education, not just making a sale.",
      "Second, choose your first market by logistics, not glamour. A neighbouring country with a short transit time will forgive your beginner mistakes. A far-flung market with strict customs will not.",
      "Third, get your documents reviewed by someone who has done it before. One wrong HS code or a mismatched invoice value can hold a container for weeks. This is exactly the kind of review I do in my coaching sessions.",
      "Finally, remember: every seasoned exporter you admire once stood exactly where you are standing now. The difference is simply that they shipped.",
    ],
  },
  {
    slug: "five-documentation-mistakes",
    title: "Five Documentation Mistakes That Cost New Exporters Money",
    excerpt:
      "Customs doesn't care how good your product is. These five paperwork errors are responsible for most of the delays and penalties I see.",
    category: "Export-Import",
    date: "May 2026",
    readTime: "5 min read",
    content: [
      "In four decades of trade, I have seen more deals damaged by paperwork than by price. Here are the five mistakes I correct most often.",
      "One: mismatched values across documents. Your commercial invoice, packing list and shipping bill must tell the same story. Customs systems cross-check automatically now.",
      "Two: the wrong Incoterm for your capability. Agreeing to DDP when you have no agent in the destination country is a promise you cannot keep.",
      "Three: vague product descriptions. 'Garments' gets flagged. '100% cotton knitted men's t-shirts, HS 6109.10' clears.",
      "Four: ignoring the letter of credit fine print. A single discrepancy gives the bank the right to refuse payment. Read every clause twice.",
      "Five: no document SOP. If your documentation lives in one person's head, your business is one resignation away from chaos. Write it down — or let me help you build the SOP.",
    ],
  },
  {
    slug: "ai-wont-replace-trade-business",
    title: "AI Won't Replace Your Trade Business — But a Competitor Using AI Might",
    excerpt:
      "The businesses that win the next decade of global trade will pair human relationships with intelligent tools. Here's where to start.",
    category: "AI & Digital",
    date: "April 2026",
    readTime: "7 min read",
    content: [
      "I spent forty years building trade relationships over handshakes and long phone calls. So believe me when I say: AI is not coming for the relationship. It is coming for the drudgery around it.",
      "Start with enquiries. An AI-assisted first response — drafted in seconds, personalised by you in a minute — means no buyer waits two days for a quote ever again.",
      "Then look at research. Market selection, buyer background checks, price benchmarking: work that took my team a week now takes an afternoon.",
      "Your website matters more than your visiting card now. Buyers verify you online before they reply to your email. A slow, dated website quietly kills deals you never knew you had.",
      "The winning formula is not AI instead of experience. It is experience, amplified by AI. That combination is exactly what I help traditional businesses build.",
    ],
  },
  {
    slug: "forty-years-of-negotiation",
    title: "What Forty Years of Negotiation Taught Me About Trust",
    excerpt:
      "Price closes deals, but trust opens markets. Lessons from four decades of sitting across the table from buyers in dozens of countries.",
    category: "Mentorship",
    date: "March 2026",
    readTime: "5 min read",
    content: [
      "Every culture negotiates differently, but one thing is universal: people buy from people they trust. And trust, in trade, is built from small kept promises.",
      "Reply when you said you would reply. Ship a sample when you said you would ship it. Quote honestly, even when the honest number is uncomfortable. These tiny acts compound into a reputation that travels ahead of you.",
      "Never win a negotiation so completely that the other side loses face. A squeezed supplier cuts corners. A resentful buyer disappears after one order. The best deals leave both sides eager for the next one.",
      "And when something goes wrong — and in forty years, things will go wrong — pick up the phone before they do. Bad news delivered early is a problem solved together. Bad news discovered late is a relationship ended.",
      "This is the philosophy behind everything I teach, whether we are discussing a letter of credit or a landing page.",
    ],
  },
];
